import * as ng from 'angular';

export const PdfViewer = () => (<angular.IDirective>{

    restrict: 'E',

    link: (scope: any, element: JQLite, attrs: any) => {

        element.empty();
        let objectElem = {};

        let data = scope.$eval(attrs.src);
        let type = scope.$eval(attrs.type);

        if (type && type.indexOf('application') !== -1 && scope.$parent.responseType === 'base64') {
            data = 'data:' + type + ';base64,' + data;
        }

        if (type === undefined) {
            type = type === undefined ? 'application/pdf' : type;
            data = 'data:' + type + ';base64,' + data;
        }

        if (type === 'text/xml') {
          element.replaceWith(`<textarea disabled style='width:100%;height:80vh;resize:none;'>${data}${data}${data}${data}${data}${data}${data}${data}${data}${data}</textarea>`);
        } else {
          element.replaceWith('<object data="' + data + '" type="' + type + '"><embed src="' + data + '" type="' + type + '" /></object>');
        }

    }
});



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app/commons/directives/pdf-viewer/pdf-viewer.directive.ts